import React from 'react';

import { LANDING_HOME } from './basisLinks';

// [Basis chrome] La marca del explorador es la de la landing.
//
// Port de frontend_landing/src/components/BrandLogo.astro: el isotipo (hexagono)
// y el wordmark como DOS imagenes, a 24 px y a 15 px de alto, con gap de 0,5rem.
// Los tamanos y el aspecto viven en nextjs/basis-chrome.css (.bs-logo*).
//
// POR QUE YA NO SALE DE NEXT_PUBLIC_NETWORK_LOGO. Hasta 2026-10 el chrome pintaba
// el lockup de un solo SVG que el entorno declara en
// file:///basis-brand/logo.svg, es decir, un fichero del volumen de marca que el
// contenedor lee al arrancar. Con los tres colores nuevos --degradado cian ->
// azul pastel, wordmark Gris oscuro y Blanco-- eso dejaba la marca de la cabecera
// a merced de que alguien actualizara ese volumen a la vez que la imagen. Los
// tres ficheros viajan ahora DENTRO de la imagen, en public/basis-chrome/, que es
// donde ya viven los logos de credenciales y certificaciones: lo que se ve lo
// fija este parche y no el despliegue. Son byte a byte los de la landing
// (public/favicon.svg y public/logos/brand/).
//
// El wordmark es el mismo trazo en dos tintas de la marca: Gris oscuro #3c3c3c
// sobre claro y Blanco #fafefe sobre el pie gris --y sobre la pagina del tema
// oscuro, que tambien es #3c3c3c--. El isotipo es el degradado Cian #42ede5 ->
// Azul pastel #76b8fe y se lee igual sobre los dos fondos. Hasta 2026-10 el
// wordmark era azul marino #0B2540 y el degradado tenia tres paradas
// (#00FFCC, #22D3EE, #00CCFF): ninguno esta en el manual de marca.

export const LOGO_ISOTYPE = '/basis-chrome/basis-isotype.svg';
export const LOGO_WORDMARK = '/basis-chrome/basis-wordmark.svg';
export const LOGO_WORDMARK_WHITE = '/basis-chrome/basis-wordmark-white.svg';

interface Props {
  // «ink» para fondos claros (la cabecera), «white» para los oscuros (el pie).
  variant?: 'ink' | 'white';
  // El pie carga por debajo del pliegue y puede diferir sus imagenes.
  lazy?: boolean;
  className?: string;
}

const BasisLogo = ({ variant = 'ink', lazy = false, className }: Props) => {
  const loading = lazy ? 'lazy' : undefined;

  return (
    // El logo sale a la landing, como en la landing. Se aparta de la convencion
    // de producto --en un explorador el logo suele llevar a su propia portada--
    // por decision explicita: el chrome es el de basisnetwork.com.co y se
    // comporta como tal. La portada del explorador queda a un clic en
    // «Explorador -> Inicio».
    <a href={ LANDING_HOME } className={ `bs-logo${ className ? ` ${ className }` : '' }` }>
      <img
        src={ LOGO_ISOTYPE }
        alt=""
        aria-hidden="true"
        width={ 256 } height={ 256 }
        className="bs-logo__mark"
        loading={ loading }
        decoding="async"
      />
      { /* width/height nativos: reservan el aspect-ratio y evitan CLS; el alto
           real lo fija la clase. */ }
      <img
        src={ variant === 'white' ? LOGO_WORDMARK_WHITE : LOGO_WORDMARK }
        alt=""
        aria-hidden="true"
        width={ 3004 } height={ 338 }
        className="bs-logo__word"
        loading={ loading }
        decoding="async"
      />
      { /* El nombre de marca viaja como texto real: lo leen lectores de pantalla
           y rastreadores. */ }
      <span className="bs-sr-only">Basis Network</span>
    </a>
  );
};

export default React.memo(BasisLogo);
